import request from '../utils/request'

//获取AI视力报告
export function getReportListApi(params) {
  return request({
    method: 'get',
    url: `/api/wechat/aivision/report/list/${params.studentId}`,
    params
  })
}

//提交Ai视力报告表单
export function submitReportFormApi(data) {
  return request({
    method: 'post',
    url: '/api/wechat/aivision/report',
    data
  })
}

// 获取Ai视力报告详情
export function getReportDetailDataApi(data) {
  return request({
    method: 'get',
    url: `/api/wechat/aivision/report/info/${data.aiInfoId}`,
  })
}